const heroSlider = (width) => {

    const slider = $('.js-hero-slider');

    if ( slider.length ) {
        const hiddenClass  = 'hero--hidden';
        const element      = $('.js-hero-element');

        slider.on('init', function(event, slick){
            slider.removeClass(hiddenClass);
            window.heroHeight = slider.height() + 35;
        });
        slider.on('init beforeChange afterChange', function(event, slick, currentSlide){
            const prevArrow = $('.js-hero-arrow-prev');
            const nextArrow = $('.js-hero-arrow-next');

            let current = $(slick.$slides.get(currentSlide));

            let prevText = current.attr('data-hero-prev-button');
            let nextText = current.attr('data-hero-next-button');

            prevArrow.html(prevText);
            nextArrow.html(nextText);

        });

        slider.slick({
            slide           : '.hero__element',
            rows            : 0,
            slidesToShow    : 1,
            infinite        : true,
            arrows          : true,
            dots            : true,
            pauseOnHover    : false,
            autoplay        : true,
            autoplaySpeed   : 10000,
            prevArrow       : '<button type="button" class="slick-prev"><span class="slick-arrow__icon"><svg class="i"><use xlink:href="#arrow-left"/></svg></span><span class="slick-arrow__text"><span class="value js-hero-arrow-prev"></span></span></button>',
            nextArrow       : '<button type="button" class="slick-next"><span class="slick-arrow__text "><span class="value js-hero-arrow-next"></span></span><span class="slick-arrow__icon"><svg class="i"><use xlink:href="#arrow-right"/></svg></span></button>',
            appendArrows    : $('.js-hero-arrows', slider),
            appendDots      : $('.js-hero-dots', slider),
            responsive      : [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: false
                    }
                }
            ],
            customPaging:function (a, b) {
                return '<div class="wrapper" data-anim="base wrapper"><div class="circle" data-anim="base left"></div><div class="circle" data-anim="base right"></div></div>'
            }
        });

        //this positioning is no longer used
        $(window).on('load resize', function(){
            element.each(function(){
                let position = $(this).attr('data-hero-image-position');

                if ( window.deviceWidth <= width ) {
                    $(this).find('.js-hero-element-image').css('right', '');
                }
                else {
                    $(this).find('.js-hero-element-image').css('right', position);
                }
            })
        });

    }
}